const scrollToTopButton = document.querySelector( '.footer__scroll-to-top' );
if ( scrollToTopButton ) {
    scrollToTopButton.addEventListener( 'click', () => {
        window.scrollTo( {top: 0, behavior: 'smooth'} );
    } );
}
